import ajax from '@utils/ajax';

export const login = async (data) =>
  await ajax('POST', '/capsiminbox/authoring-platform/login', JSON.stringify(data));

export const logout = async () => await ajax('GET', '/capsiminbox/authoring-platform/logout');

export const createAccount = async (data) =>
  await ajax('POST', '/capsiminbox/authoring-platform/create-account', JSON.stringify(data));

export const deleteAccount = async () =>
  await ajax('PUT', '/capsiminbox/authoring-platform/update-is-deleted');

export const searchAuthors = async (data) =>
  await ajax('GET', `/capsiminbox/authoring-platform/search-authors?searchString=${data}`);

export const sendCopy = async (data) =>
  await ajax('POST', '/capsiminbox/authoring-platform/send-copy', JSON.stringify(data));

export const updateIsDeleted = async () =>
  await ajax('PUT', '/capsiminbox/authoring-platform/update-is-deleted');

const rootUrl = '/capsiminbox/admin/api/authors';

export const createAuthor = async (payload) =>
  await ajax('POST', `${rootUrl}`, JSON.stringify(payload));

export const updateAuthor = async ({ authorKey, payload }) =>
  await ajax('PUT', `${rootUrl}/${authorKey}`, JSON.stringify(payload));

export const deleteAuthor = async (authorKey) => await ajax('DELETE', `${rootUrl}/${authorKey}`);

export const getMilestonesForAuthor = async (authorKey) =>
  await ajax('GET', `/capsiminbox/authoring-platform/milestones/${authorKey}`);

export const setMilestoneForAuthor = async (payload) =>
  await ajax('POST', `/capsiminbox/authoring-platform/set-milestone`, JSON.stringify(payload));

export const getRemainingMilestones = async (authorKey) =>
  await ajax('GET', `/capsiminbox/authoring-platform/remaining-milestones/${authorKey}`);

export const getPlaylistDataForAuthor = async (playListId) =>
  await ajax('GET', `/capsiminbox/authoring-platform/playlist/${playListId}`);
